export default {
    name: "categorias",
      children: [
        {
          path: '',
          name: 'lista-categorias',
          component: () => import('@/modules/course/components/CategoryList.vue'),
           meta: { countViews: true }
        },
        {
          path: ':name',
          name: 'categoria-capacitaciones',
          component: () => import('@/modules/course/components/CourseList.vue'),
           meta: { countViews: true }
        },
      ],
  };